import React from 'react';
import {Message} from 'epic-diesel-common';
import {useDispatch} from 'react-redux';

import {Button} from '../../../../components';
import {useStyles} from './LoadMore.style';
import payoutActions from '../../../../actions/payout.actions';

interface Props {
    isLimited: boolean;
    isLoading: boolean;
    loadPayoutList: (data) => void;
}

interface Paging {
    count: number;
    start: number;
}

const DEFAULT_PER_PAGE = 6;

export const LoadMore: React.FC<Props> = ({isLimited, loadPayoutList, isLoading}) => {
    const styles = useStyles();
    const dispatch = useDispatch();

    const [paging, setPaging] = React.useState<Paging>({start: 0, count: 6});

    React.useEffect(() => {
        loadPayoutList(paging);
        return () => {
            dispatch(payoutActions.resetReportListPaganiton());
        };
    }, []);

    const handlerOnLoadMore = e => {
        e.preventDefault();
        const newPageing = {...paging, start: paging.start + DEFAULT_PER_PAGE};
        setPaging(newPageing);
        loadPayoutList(newPageing);
    };

    if (isLimited) {
        return null;
    }

    return (
        <div className={styles.loader}>
            <Button
                className={styles.buttonWrapper}
                loading={isLoading}
                type="button"
                onClick={handlerOnLoadMore}>
                <Message code="epic.affiliate.news.loadMore" />
            </Button>
        </div>
    );
};
